export default function Divider() {
  return (
    <div className="tw-h-px tw-w-full tw-bg-greyscale-label tw-my-4 lg:tw-hidden"></div>
  );
}
